




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import StyledRadio from '@/views/common/StyledRadio.vue';
import MegacardStore from '@/stores/user/megacard.store';
import { AddressDto } from '@/api';
import MegacardConnector from '@/views/account/MegacardConnector.vue';
import { MegacardChoice, MegacardChoiceEvent } from '@/util/megacard-connector-models';

@Component({
  components: {MegacardConnector, StyledRadio, LoadingIndicator},
})
export default class RegisterMegacardSelector extends Vue {
  @Prop({required: true})
  public initialChoice!: MegacardChoice;

  public choices = MegacardChoice;
  public choice: MegacardChoice | null = null;
  private megacardStore = getModule(MegacardStore, this.$store);

  public mounted(): void {
    this.choice = this.initialChoice;
  }

  @Watch('choice')
  public onChoiceChange(): void {
    this.megacardStore.resetRequestedMegacard();
    this.emitChange();
  }

  public handleConnectionChange(addressData?: AddressDto): void {
    if (this.choice === MegacardChoice.HAVE) { // if choice is changed while loading
      this.emitChange(addressData);
    }
  }

  private emitChange(address?: AddressDto) {
    if (this.choice === null) {
      this.choice = MegacardChoice.REJECT;
    }
    const event: MegacardChoiceEvent = {choice: this.choice, address};
    this.$emit('change', event);
  }
}
